module.exports = __webpack_public_path__ + "static/media/personal_tags.5725e92a.svg";